import { useState } from "react"
import { Accordion, Button } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { FaCaretDown, FaCaretUp } from "react-icons/fa"

function AcordionRespuestas({t, item}){
    const [directionDown, setDirectionDown] = useState(true)


    return(
        <Accordion>
            <Accordion.Toggle as={Button} variant="link" className="text-dark p-0 no-underline outline-none shadow-none" eventKey="0"
            onClick={e=>setDirectionDown(!directionDown)}>
                {t('respuestas')} {directionDown ? <FaCaretDown /> : <FaCaretUp />}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
                <div className="bx-1 text-secondary">
                    {
                        item.answers.map((ans,i)=>(
                            <div className="mb-2" key={i}>
                                <span className="font-size-09rem mb-2 font-weight-bold-600">{ans.survey.title}</span>
                                {
                                    ans.answers.map((a, ind)=>(
                                        <span key={ind} className="d-block font-size-09rem pl-1">{a}</span>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
            </Accordion.Collapse>                                                                              
        </Accordion>
    )
}

export default withTranslation()(AcordionRespuestas)